export const CHUYEN_HANG_PERMISSION_CODES = {
  WEB_BH_CHUYEN_HANG_LIST: 'WEB_BH_CHUYEN_HANG_LIST',
  WEB_BH_CHUYEN_HANG_DETAIL: 'WEB_BH_CHUYEN_HANG_DETAIL',
  WEB_BH_CHUYEN_HANG_ADD: 'WEB_BH_CHUYEN_HANG_ADD',
  WEB_BH_CHUYEN_HANG_EDIT: 'WEB_BH_CHUYEN_HANG_EDIT',
  WEB_BH_CHUYEN_HANG_DELETE: 'WEB_BH_CHUYEN_HANG_DELETE',
  WEB_BH_CHUYEN_HANG_THEO_DOI: 'WEB_BH_CHUYEN_HANG_THEO_DOI',
  WEB_BH_CHUYEN_HANG_IMPORT: 'WEB_BH_CHUYEN_HANG_IMPORT',
  WEB_BH_CHUYEN_HANG_EXPORT: 'WEB_BH_CHUYEN_HANG_EXPORT',
} as const

export const CHUYEN_HANG_MUTATE_PERMISSIONS = [
  CHUYEN_HANG_PERMISSION_CODES.WEB_BH_CHUYEN_HANG_ADD,
  CHUYEN_HANG_PERMISSION_CODES.WEB_BH_CHUYEN_HANG_EDIT,
  CHUYEN_HANG_PERMISSION_CODES.WEB_BH_CHUYEN_HANG_DELETE,
  CHUYEN_HANG_PERMISSION_CODES.WEB_BH_CHUYEN_HANG_IMPORT,
  CHUYEN_HANG_PERMISSION_CODES.WEB_BH_CHUYEN_HANG_EXPORT,
] as const
